/* global graphql  */
import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'
import Header from '../components/header-new'
import HeroVideo from '../components/hero-video'
import Footer from '../components/footer-new'
import ScrollingBanner from '../components/scrolling-banner'
import CaseStudies from '../components/case-studies'

const MadeYouLookPage = ({ data }) => {
  // Description is hardcoded here because it's too long for the field in CMS
  let playbook = {
    description: 'In today\'s time starved world, capturing attention is our intention.\n\nWe partnered with neuroscientists on a pioneering research study to explore how the brain actively processes information. This effort has been translated into a new playbook that shows how to create campaigns that capture attention to drive business results.'
  }
  playbook = { ...data.drupalProject, ...playbook }

  return (
    <div className='wrapper--page page--madeyoulook'>
      <Helmet title='Made You Look - ATTN:' />
      <Header theme='dark' />
      <div className='hero--fullbleed'>
        <HeroVideo
          desktopPosterSrc={data.drupalMedia.image_desktop.url}
          mobilePosterSrc={data.drupalMedia.image_mobile.url}
          desktopVideoSrc={data.drupalMedia.loop_desktop.file.url}
          mobileVideoSrc={data.drupalMedia.loop_mobile.file.url}
        />
      </div>
      <div className='madeyoulook-intro'>
        <div className='madeyoulook-intro__body'>
          If you want people to pay attention, you have to learn how to earn it
          by telling stories that the brain can't ignore.
        </div>
      </div>
      <ScrollingBanner background='black' text='The playbook' length={10} />
      <div className='madeyoulook-playbook'>
        <CaseStudies caseStudies={[{ node: playbook }]} cta='Watch the video' />
      </div>
      <div className='madeyoulook-contact'>
        <div className='madeyoulook-contact__body'>
          <h2 className='madeyoulook-contact__header'>
            Get the playbook
          </h2>
          <p className='madeyoulook-contact__info'>
            Contact us for a digital version of our playbook or for more
            information on a live session for your team.
          </p>
          <p className='madeyoulook-contact__email'>Email: <a href='mailto:madeyoulook@attn.com'>madeyoulook@attn.com</a></p>
        </div>
      </div>
      <Footer />
    </div>
  )
}

MadeYouLookPage.propTypes = {
  data: PropTypes.object
}

export default MadeYouLookPage

export const query = graphql`
  query MadeYouLookPage {
    drupalMedia(pid: {eq: "172"}) {
      image_desktop {
        url
      }
      image_mobile {
        url
      }
      loop_mobile {
        file {
          url
        }
      }
      loop_desktop {
        file {
          url
        }
      }
    }
    drupalProject(pid: {eq: "173"}) {
      id
      eyebrow
      title
      description
      image_mobile {
        url
      }
      image_desktop {
        url
      }
      loop_mobile {
        file {
          url
        }
      }
      loop_desktop {
        file {
          url
        }
      }
      video_desktop {
        file {
          url
        }
      }
      video_mobile {
        file {
          url
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/madeyoulook.js